import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const service = axios.create({
  baseURL: '/xunshanke-server',
  timeout: 5000
})

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }

    // 统一处理 POST 请求的参数 - 使用 FormData 格式（与 Postman 一致）
    // 注意：如果 data 已经是 FormData（如文件上传），则不需要处理
    if (
      config.method === 'post' &&
      config.data &&
      typeof config.data === 'object' &&
      !(config.data instanceof FormData)
    ) {
      const formData = new FormData()
      Object.keys(config.data).forEach((key) => {
        formData.append(key, config.data[key])
      })
      config.data = formData
      // 不要手动设置 Content-Type，让浏览器自动设置 multipart/form-data 和 boundary
      delete config.headers['Content-Type']
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 处理 9999 状态码：Token 过期或无效，跳转登录页
    if (res.code === '9999' || res.code === 9999) {
      // 提示错误信息
      import('element-ui').then((Element) => {
        Element.Message({
          message: res.message || '登录状态已过期，请重新登录',
          type: 'error',
          duration: 3000
        })
      })
      // 清除本地 token
      localStorage.removeItem('token')
      // 跳转到登录页
      window.location.href = '/#/login'
      return Promise.reject(new Error(res.message || '9999'))
    }

    // API返回code: "0"表示成功，其他表示失败
    if (res.code !== '0' && res.code !== 0) {
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default service
